export const globalRoutes: GlobalRoutes = {
  dashboard: '/',
};

interface GlobalRoutes {
  dashboard: string;
}
